<script setup lang="ts">
import { getTranslations } from '@/lib/util/i18n';
import { CoButton } from '@deputy/copilot2';
import { useTimesheetStore } from '@/stores/timesheets';

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'shift-action-status',
});

const emit = defineEmits(['reloadShiftCard', 'logout']);

const timesheets = useTimesheetStore();
</script>

<template>
  <!-- TODO - design for error handling -->
  <div class="shift-action-error">
    <img src="../assets/images/shift-action-error.png" />
    <div class="__title">{{ t('shift-action-error:title') }}</div>
    <div>
      <div class="__details">
        {{
          timesheets.getUserError()?.message || t('shift-action-error:details')
        }}
      </div>
    </div>
    <div class="__actions">
      <CoButton type="primary" size="large" @click="emit('reloadShiftCard')">{{
        timesheets.getUserError()
          ? t('shift-action-error:close')
          : t('shift-action-error:try-again')
      }}</CoButton>
      <CoButton size="large" @click="emit('logout')">{{
        t('shift-action-error:logout')
      }}</CoButton>
    </div>
  </div>
</template>

<style scoped>
.shift-action-error {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-content: space-evenly;
}

img {
  width: 100px;
  height: 100px;
  margin-bottom: 24px;
}
.__title {
  font-weight: 500;
  font-size: 30px;
  line-height: 30px;
  color: var(--co-text-primary);
  margin-bottom: 32px;
}
.__details {
  font-weight: 400;
  font-size: 17px;
  line-height: 24px;
  color: var(--co-text-primary);
  margin-bottom: 32px;
}
.__actions {
  width: 100%;
  display: flex;
  gap: 1rem;
}
.co-button {
  width: 100%;
}
</style>
